// extracted by mini-css-extract-plugin
module.exports = {"row":"Checkout_row__4OAZ5"};